export default {
  multiCall: '0x1Ee38d535d541c55C9dae27B12edf090C608E6Fb',
  acs: '0x4197C6EF3879a08cD51e5560da5064B773aa1d29',
};
